<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<h4 class="text-center" mat-dialog-title i18n="@@success">Success</h4>

<div mat-dialog-content>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
    <p i18n="@@removalFinishedInfo">Your request for removal has been successfully transmitted!</p>
    <p i18n="@@removalFinishedInfo2">Please leave animal corpses out of an unsafe area.</p>
    <p i18n="@@removalFinishedId">Its ID is:</p>
    <h2 class="text-center">{{removal.id}}</h2>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <button class="btn btn-primary btn-rounded  btn-block" (click)="close()" i18n="@@close">Close</button>
  </div>
</div>
